module.exports = __webpack_public_path__ + "img/clip.eeee00ec.svg";